import en1 from './en1'
export default {

  route: {
    ...en1,
    platmanagemtnt: 'Platform',
    branchlist: 'Branches',
    fabriclist: 'Fabric Suppliers',
    designers: 'Designers',    
    PLT文件价格: 'PLT File Price',
    '模板内容': 'Template Content',
    '管理员': 'Admin',
    '确定要删除当前视频吗?': 'Delete this video?',
    '地址': 'Address',
    '播放终端': 'Terminals',
    '指定位置': 'Location',
    '升级会员处': 'Membership Upgrade',
    '未指定': 'Unspecified',
    '标题:': 'Title:',
    '请录入视频标题!': 'Please enter video title!',
    '请录入视频标题': 'Enter video title',
    '分类:': 'Category:',
    '请选择视频分类!': 'Please select video category!',
    '视频地址:': 'Video URL:',
    '封面图片:': 'Cover Image:',
    '播放终端:': 'Terminals:',
    '指定位置:': 'Location:',
    '排序:': 'Sort:',
    '请录入视频地址或点击浏览上传视频!': 'Please enter video URL or browse to upload!',
    '请上传视频封面图片!': 'Please upload video cover image!',
    '请选择播放终端!': 'Please select playback terminals!',
    '请录入排序值!': 'Please enter sort value!',
    '平台客户': 'Platform Customers',
    '分店客户': 'Branch Customers',
    '面料商客户': 'Fabric Supplier Customers',
    '成衣生产商客户': 'Garment Manufacturer Customers',
    '新增视频文件': 'Add Video File',
    '分类名称': 'Category Name',
    '新增分类': 'Add Category',
    '新增视频分类': 'Add Video Category',
    '录入分类名称': 'Enter category name',
    '用户名密码登录': 'Username & Password Login',
    '用户名/手机号码': 'Username / Phone Number',
    '密码': 'Password',
    '记住账号': 'Remember Account',
    '忘记密码': 'Forgot Password',
    '登录': 'Login',
    '手机验证码登录': 'Phone Code Login',
    '输入手机号码': 'Enter phone number',
    '输入验证码': 'Enter verification code',
    '微信扫码登录': 'WeChat QR Login',
    '绑定手机号': 'Bind Phone Number',
    '请录入11位手机号码': 'Enter 11-digit phone number',
    '请录入手机号码': 'Enter phone number',
    '请录入6位短信验证码': 'Enter 6-digit SMS code',
    '店面未激活，请等待激活后再登录！': 'Store not activated, please wait!',
    '店面已关闭，如需开通，请联系管理员处理！': 'Store closed, contact admin!',
    '店面已锁定，请联系管理员处理！': 'Store locked, contact admin!',
    '绑定成功,并自动完成登录。': 'Bound and logged in automatically.',
    '请输入正确的验证码': 'Enter correct verification code',
    '请输入正确的手机号': 'Enter correct phone number',
    '获取验证码失败': 'Failed to get code',
    '手机号码未注册': 'Phone number not registered',
    '请录入正确的手机号码！': 'Enter correct phone number!',
    '输入参数名称开始检索': 'Enter parameter name to search',
    '参数名称': 'Parameter Name',
    '参数说明': 'Description',
    '参数值': 'Value',
    '制版师回复使用模板': 'Patternmaker reply template',
    '客户回复使用模板': 'Customer reply template',
    '开通线下支付': 'Enable offline payment',
    '开通支付宝支付': 'Enable Alipay',
    '件': 'pcs',
    '折': '% off',
    '点击查看发货人': 'View sender',
    '点击查看模板内容': 'View template',
    '点击查看/编辑账号信息': 'View/edit account',
    '例：四川省成都市清羊区成明路423号': 'e.g. 423 Chengming Road',
    '例：张三': 'e.g. Zhang San',
    '例：18930888888': 'e.g. 18930888888',
    '编辑收款账号信息': 'Edit Receiving Account',
    '开户名称:': 'Account Name:',
    '请录入开户名称!': 'Enter account name!',
    '银行地址:': 'Bank Address:',
    '请录入开户银行!': 'Enter bank name!',
    '开户账号:': 'Account Number:',
    '请录入开户账号!': 'Enter account number!',
    '短信验证:': 'SMS Verification:',
    '请录入验证码!': 'Enter verification code!',
    '发送验证码': 'Send Code',
    '发送至': 'Send to',
    '验证码不正确': 'Incorrect code',
    '资产信息': 'Asset Info',
    '可提现额度：': 'Withdrawable:',
    '账户总额度：': 'Total:',
    '今日入账-￥': 'Today Income-￥',
    '已提现': 'Withdrawn',
    '不可提现': 'Not Withdrawable',
    '未提现': 'Not Withdrawn',
    '历史入账-￥': 'History Income-￥',
    '入账时间：': 'Income Time:',
    '已收款': 'Received',
    '历史提现': 'Withdrawal History',
    '收款信息': 'Payment Info',
    '开户行:': 'Bank:',
    '请录入银行名称如：中国银行!': 'Enter bank name!',
    '请录入银行名称如：中国银行': 'Enter bank name',
    '账号名称:': 'Account Name:',
    '请录入持卡人名称!': 'Enter cardholder name!',
    '请录入持卡人名称': 'Enter cardholder name',
    '银行卡号:': 'Card Number:',
    '请录入银行卡号!': 'Enter card number!',
    '请录入银行卡号': 'Enter card number',
    '可提现额度': 'Withdrawable',
    '提现金额必须大于0': 'Amount must be > 0',
    '提现申请成功': 'Withdrawal submitted',
    '还没有设置提现账号，请先设置提款账号后再提现。': 'Set withdrawal account first.',
    '订单客户': 'Customer',
    '入账原由': 'Reason',
    '收退款': 'Refund',
    '提现完结时间': 'Complete Time',
    '发货人信息': 'Sender Info',
    '发货人姓名:': 'Sender Name:',
    '请录入发货人姓名!': 'Enter sender name!',
    '发货人电话:': 'Sender Phone:',
    '请录入发货人电话!': 'Enter sender phone!',
    '公司名称:': 'Company:',
    '请录入公司名称!': 'Enter company name!',
    '发货地邮编:': 'Zip Code:',
    '请录入发货地邮编!': 'Enter zip code!',
    '发货地省:': 'Province:',
    '请录入发货地省!': 'Enter province!',
    '发货地市:': 'City:',
    '请录入发货地市!': 'Enter city!',
    '发货地县:': 'District:',
    '请录入发货地县!': 'Enter district!',
    '详细地址:': 'Address:',
    '请录入详细地址!': 'Enter address!',
    '当前您的帐号未绑定手机号为了保障您的权益,': 'Your account is not bound to a phone number.',
    '请务必绑定手机号': 'Please bind your phone number',
    '输入视频标题检索': 'Search by video title',
    ...en1
  }
}
